<template>
  <div
    :key="`tooltip-${key}`"
    class="botao-container"
    @click="handleClick"
    v-b-tooltip.hover
    :title="tooltip"
  >
    <BotaoIcone
      v-if="arredondadoDireita && tipo != 'icone'"
      :icone="icone"
      :cor="cor"
      :desabilita="desabilita"
      :loading="loading"
      :arredondadoEsquerda="arredondadoEsquerda"
      :arredondadoDireita="arredondadoDireita"
      :tipoLoading="tipoLoading"
    />

    <BotaoTipoIcone
      v-if="tipo == 'icone'"
      :cor="cor"
      :desabilita="desabilita"
      :nome="nome"
      :icone="icone"
      :arredondadoEsquerda="arredondadoEsquerda"
      :arredondadoDireita="arredondadoDireita"
      :padding="padding"
      :tamanho="tamanho"
      :loading="loading"
    />

    <BotaoTipoNome
      v-else
      :cor="cor"
      :desabilita="desabilita"
      :nome="nome"
      :arredondadoEsquerda="arredondadoEsquerda"
      :arredondadoDireita="arredondadoDireita"
      :arredondado="arredondado"
    />

    <BotaoIcone
      v-if="arredondadoEsquerda && tipo != 'icone'"
      :icone="icone"
      :cor="cor"
      :desabilita="desabilita"
      :loading="loading"
      :arredondadoEsquerda="arredondadoEsquerda"
      :arredondadoDireita="arredondadoDireita"
      :tipoLoading="tipoLoading"
    />
  </div>
</template>

<script>
import BotaoIcone from "./BotaoIcone.vue";
import BotaoTipoNome from "./BotaoTipoNome.vue";
import BotaoTipoIcone from "./BotaoTipoIcone.vue";

export default {
  name: "BotaoPadrao",
  components: {
    BotaoIcone,
    BotaoTipoNome,
    BotaoTipoIcone
  },
  props: {
    nome: String,
    icone: String,
    padding: String,
    tamanho: String,
    tooltip: String,
    desabilita: Boolean,
    loading: Boolean,
    arredondadoEsquerda: Boolean,
    arredondadoDireita: Boolean,
    arredondado: Boolean,
    click: Function,
    cor: String,
    tipo: String
  },
  data() {
    return {
      key: 0,
      tipoLoading: "5"
    };
  },
  watch: {
    tooltip() {
      setTimeout(() => {
        this.key += 1;
      }, 300);
    }
  },
  methods: {
    handleClick() {
      if (!this.desabilita) {
        this.click ? this.click() : null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.botao-container {
  display: flex;
  width: fit-content;
  height: fit-content;
  user-select: none;
  // cursor: pointer;
}


</style>
